import React from "react";
import { Card, Descriptions, Row, Col } from "antd";
import { formatPhoneNumber } from "@/utils/utils";

// Inline styles
const rowStyle = { gutter: [16, 16], justify: "space-between" };
const cardStyle = {
  style: { height: "100%" },
  headStyle: { color: "white", backgroundColor: "#22316C" },
};
const grid = { md: { span: 12 }, sm: { span: 24 } };

export const DealerDetails = ({ dealer }) => {
  if (!dealer) return null;

  return (
    <Row {...rowStyle}>
      <Col {...grid}>
        <Card type="inner" title="Shipper" {...cardStyle}>
          <Descriptions title={dealer?.name ?? "N/A"} column={1}>
            <Descriptions.Item key="address" style={{ paddingBottom: "0" }}>
              <p>{dealer.completedAddress ?? "N/A"}</p>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col {...grid}>
        <Card type="inner" title="Shipper Contact" {...cardStyle}>
          <Descriptions title={dealer?.name ?? "N/A"} column={1} size="small" />
          <Descriptions.Item key="phone" label="Phone" style={{ paddingBottom: "0" }}>
            {formatPhoneNumber(dealer?.phoneNumber)}
          </Descriptions.Item>
        </Card>
      </Col>
    </Row>
  );
};

export default DealerDetails;
